import { GiftCardRedemptionComponentModule } from '@b2b/common/components/gift-card-redemption/gift-card-redemption.component';
import { NoticesComponentModule } from '@b2b/common/components/notices';
import { MaskDirectiveModule } from '@b2b/common/directives/mask/mask.directive';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { safeApply } from '@b2b/common/rxjs';
import { CartService, CartServiceModule, PaymentService, PaymentServiceModule } from '@b2b/common/services';
import { ApiService } from '@b2b/common/services/api/types';
import {
  CheckoutProcessService,
  CheckoutProcessServiceModule,
} from '@b2b/common/services/checkout/checkoutProcess.service';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ACMEValidator, ValidateService } from '@b2b/common/services/validate';
import { coerceArray } from '@b2b/common/utils/coerce-array';
import { withCreditCardMask } from '@b2b/common/utils/masks';
import { getGiftCardRedemptionsTotal } from '@b2b/common/utils/gift-card';
import { Address, Contact, Maybe, TODO, UIBModalService } from '@b2b/types/core';
import { RefundData } from '@b2b/types/order';
import { OrdersCheckoutChargesInput } from '@b2b/types/order/api';
import { Organization } from '@b2b/types/organization';
import { Payment, SecureCheckoutProps } from '@b2b/types/payment';
import { SubscriptionDetail } from '@b2b/types/subscriptions';
import angular, { IRootScopeService, IScope, ITimeoutService } from 'angular';
import { combineLatest, map } from 'rxjs';
import { CartSecureCheckoutComponentModule } from '../../../views/application/views/cart/components/cart-secure-checkout/cart-secure-checkout.component';
import {
  PaymentAddress,
  PaymentMethod,
  PaymentProcessError,
  PaymentType,
  PaymentVM,
  RefundDataVM,
  RefundDetailsVM,
} from './types';
import { ManageSecondaryContactModalModule } from '../../../views/application/views/partners/create/controllers/ManageSecondaryContactModalController';

interface PaymentScopeProperties {
  sameContactTypeLabel: TODO;
  isAccount: TODO;
  paymentPolicy: TODO;
  corsCheckoutCreditCardMessage: TODO;
  hidePaymentMethods: TODO;
  contact: TODO;
  sameContact: TODO;
  useSameContact: TODO;
  payment: TODO;
  $ctrl: TODO;
  hideTicketDelivery: TODO;
  showModal: TODO;
  isAddressRequired: TODO;
  balance: TODO;
  total: TODO;
  accountContact: TODO;
  hasMembership: TODO;
  isCollapsed: TODO;
  showOrgBilling: TODO;
  addressChanged: TODO;
  giftCardRedemptionsTotal: TODO;
  reservationId: TODO;
  orderId: TODO;
  initialGiftCardRedemptions: TODO;
}

PaymentDirective.$inject = [
  '$timeout',
  '$uibModal',
  'ApiService',
  'PaymentProcessorService',
  'ValidateService',
  'HelpersService',
  'CartService',
  'ThemesHelperService',
  'NoticeFactory',
  'PaymentService',
  'CheckoutProcessService',
];

function PaymentDirective(
  $timeout: ITimeoutService,
  $uibModal: UIBModalService,
  ApiService: ApiService,
  PaymentProcessorService: TODO,
  ValidateService: ValidateService,
  HelpersService: TODO,
  CartService: CartService,
  ThemesHelperService: ThemesHelperService,
  NoticeFactory: NoticeFactory,
  paymentService: PaymentService,
  CheckoutProcessService: CheckoutProcessService
) {
  PaymentController.$inject = ['$scope', '$rootScope'];
  function PaymentController($scope: IScope & PaymentScopeProperties, $rootScope: IRootScopeService) {
    const ctrl = {
      vm: {} as PaymentVM,
      checkoutModal: {} as { dismiss: () => void },
      ticketDelivery: '',
      hideTicketDelivery: true,
      hidePaymentMethods: true,
      paymentDaysAfter: 0,
      paymentVoucher: '',
      checkNumber: '',
      chargeAmount: 0,
      otherChargeAmount: 0,
      addOnQuantity: 0,
      quantity: 0,
      total: 0,
      paymentMinimum: 0,
      paymentType: 'full' as PaymentType,
      manualEntryCardNumber: '',
      expDate: '',
      minimumPaymentAmount: '',
      validateEmail: true,
      showOptionalAddress: true,
      useSameContact: false,
      sameContact: false as TODO | false,
      originalContact: {},
      contactType: $scope.sameContactTypeLabel || 'Contact',

      isSubmitted: false,
      errors: {},
      notice: new NoticeFactory(),
      contactErrors: false as Record<string, any> | false,

      model: {
        type: '',
        contactEmail: '',
        phoneNumber: '',
        contactLastName: '',
        contactFirstName: '',
        address: {} as PaymentAddress,
        orgContactCountry: undefined as Maybe<any>,
        orgContactState: undefined as Maybe<any>,
      } as TODO,

      otherPaymentId: '',

      invoice: false,
      paymentMethod: {} as { type: PaymentMethod; name: string },
      paymentMethods: [
        { type: 'CreditCard', name: 'Credit Card' },
        { type: 'Voucher', name: 'Voucher' },
        { type: 'Check', name: 'Check' },
        { type: 'Cash', name: 'Cash' },
        { type: 'Other', name: 'Other' },
      ] as const,

      invalidVoucher: false,

      card: PaymentProcessorService.card,

      // org billing contact
      cartService: CartService,
      isLoaded: true,
      organization: null as Partial<Organization & { paymentSectionCollapsed: boolean }> | null,
      selectedContact: null as Maybe<Contact & { index: number }>,
      orgContact: '',
      orgContactAddress: null as TODO | null,
      orgContactCountry: '',
      orgContactState: '',
      contactList: [] as TODO[],
      addressList: [] as TODO[],
      countryList: [] as TODO[],
      stateList: [] as TODO[],
      showPayment: true,
      refundData: undefined as Maybe<RefundDataVM>,

      isEnabledCORSCheckout: false,
      corsCheckoutAutorenewMessage: `For Auto Renew, credit card info will be securely collected when you select "Collect CC & Place Order"`,
      corsCheckoutCreditCardMessage: `Payment will be securely collected when you select "Take Payment & Place Order"`,

      creditCardMask: withCreditCardMask(),

      initVM: function () {
        const vm$ = combineLatest({
          payment: paymentService.state$,
          cart: CartService.state$,
        }).pipe(
          map(({ payment, cart }) => {
            const total = payment.process.total;
            const paymentMethod = payment.process.paymentMethod;
            const chargeAmount = payment.process.chargeAmount;
            const autorenewInCart = cart.autorenewInCart;

            /**
             * APP-2936: remove all UI mentioning the option to use current CoF.
             *
             * instead of removing just setting always to false to always require CC info
             * all subscriptions and AR flows will be improved later
             *
             * const subscription = cart.memberships.subscription.data;
             * const subscription = null;
             */
            const subscription = cart.memberships.subscription.data;
            const refund = payment.refund.data;
            const refundDetails = refund?.refundDetails ?? [];
            const hasRefundWithCC = refundDetails.some((item) => item.paymentMethod === 'CreditCard');

            const isLoading = [payment.refund.status, cart.status, cart.memberships.subscription.status].some(
              (status) => status === 'loading'
            );

            const cardOnFile = ctrl.mapCardOnFile({ subscription, refund });

            const paymentType = total < 0 ? 'REFUND_OWED' : total === 0 ? 'NO_PAYMENT_OWED' : 'PAYMENT_OWED';
            const hasSubscription = !!subscription;
            const hasMembershipsInCart = cart.memberships.hasMemberships;
            const hasNewMembership = cart.memberships.hasNewMembership;

            return {
              state: isLoading ? 'loading' : total >= 0 ? 'payment' : 'refund',
              autorenewInCart,
              subscription,
              hasSubscription,
              hasMembershipsInCart,
              hasNewMembership,
              refund,
              hasRefundWithCC,
              total,
              paymentType,
              showCreditCardInformation:
                paymentMethod === 'CreditCard' && (ctrl.vm.autorenewInCart.enabled || chargeAmount > 0),
              messages: {
                cardWillBeChargedEachTermForAutorenewMemberships: `The member understands and agrees that their card will be charged automatically each term, at the then-current price, for Auto Renew Memberships.`,
                cardOnFileWillBeChargedEachTermForAutorenewMemberships: [
                  'The member understands and agrees that their card on file',
                  cardOnFile ? `(${cardOnFile.creditCardBrand} x${cardOnFile.ccLastFourDigits})` : '',
                  'will be charged automatically each term, at the then-current price, for Auto Renew Memberships.',
                ]
                  .filter(Boolean)
                  .join(' '),
              },
            } satisfies PaymentVM;
          })
        );

        vm$
          .pipe(
            safeApply($scope, {
              next: (vm) => {
                ctrl.vm = vm;
                ctrl.setShowPayment();
              },
            })
          )
          .subscribe();
      },

      mapCardOnFile({ subscription, refund }: { subscription: SubscriptionDetail | null; refund: RefundData | null }): {
        creditCardBrand: string;
        ccLastFourDigits: string;
      } | null {
        if (subscription) {
          return {
            creditCardBrand: subscription.onfilePaymentMethod.paymentMethodBrand,
            ccLastFourDigits: subscription.onfilePaymentMethod.ccLastFourDigits,
          };
        }

        if (refund) {
          const found = refund.refundDetails.find(
            (detail) => detail.paymentMethod === 'CreditCard' && refund.refundAmount === detail.refundAmount
          );

          if (!found) {
            return null;
          }

          return {
            creditCardBrand: found.creditCardBrand,
            ccLastFourDigits: found.ccLastFourDigits,
          };
        }

        return null;
      },

      init: function () {
        ctrl.initVM();

        if ($scope.isAccount) {
          if ($scope.paymentPolicy && $scope.paymentPolicy.ticketDelivery) {
            ctrl.ticketDelivery = $scope.paymentPolicy.ticketDelivery;
          } else {
            ctrl.ticketDelivery = 'willCall';
          }
        } else {
          ctrl.ticketDelivery = 'print';
        }

        if ($scope.corsCheckoutCreditCardMessage) {
          ctrl.corsCheckoutCreditCardMessage = $scope.corsCheckoutCreditCardMessage;
        }

        ctrl.paymentMethod = ctrl.paymentMethods[0];
        ctrl.model.type = ctrl.paymentMethod.type;

        if ($scope.hidePaymentMethods === false || $scope.hidePaymentMethods === 'false') {
          ctrl.hidePaymentMethods = false;
        }

        ctrl.setTicketDeliveryVisibility();

        if ($scope.contact) {
          console.log('Payment::init', $scope.contact);
          ctrl.updateContact($scope.contact);
        }

        if ($scope.sameContact) {
          ctrl.sameContact = $scope.sameContact;
        }
        ctrl.useSameContact = $scope.useSameContact;

        if (ctrl.useSameContact) {
          ctrl.copySameContact();
        }

        ctrl.isEnabledCORSCheckout = CheckoutProcessService.isEnabledCORSCheckout();

        // Setup fields for error handling
        PaymentProcessorService.fields.number = 'payment-number';
        PaymentProcessorService.fields.cvc = 'payment-cvc';
        PaymentProcessorService.fields.exp_month = 'payment-expire-month';
        PaymentProcessorService.fields.exp_year = 'payment-expire-year';
        PaymentProcessorService.fields.address = 'payment-address';

        $scope.$on('Payment::Process', ctrl.onPaymentProcess);
        $rootScope.$on('Payment::Process', ctrl.onPaymentProcess);
        $scope.$on('Payment::Process::Error', ctrl.onPaymentProcessError);
        $scope.$on('Payment::Reset', ctrl.onPaymentReset);
        $scope.$on('AddressCreate::Complete', ctrl.onAddressCreateComplete);
        $scope.$on('AddressCreate::Error', ctrl.onAddressCreateError);
        $scope.$on('AddressCreate::CheckError', ctrl.onAddressCreateCheckError);
        $scope.$on('AddressCreate::CheckSuccess', ctrl.onAddressCreateCheckSuccess);
        $scope.$on('$destroy', ctrl.onDestroy);

        $scope.$on('Payment::GetSecureCheckoutData', ctrl.getSecureCheckoutData);

        ctrl.calculatePaymentTotal();
        ctrl.otherChargeAmount = ctrl.total;

        $scope.$on('$destroy', $scope.$watch('externalErrors', ctrl.onExternalErrorsUpdate));
        $scope.$on('$destroy', $scope.$watch('paymentPolicy', ctrl.onPaymentPolicyUpdate));
        $scope.$on('$destroy', $scope.$watch('total', ctrl.onTotalUpdate));
        $scope.$on('$destroy', $scope.$watch('giftCardRedemptionsTotal', ctrl.onGiftCardRedemptionsTotalUpdate));
        $scope.$on('$destroy', $scope.$watchCollection('contact', ctrl.onContactUpdate));
        $scope.$on('$destroy', $scope.$watchCollection('sameContact', ctrl.onSameContactUpdate));
        $scope.$on('$destroy', $scope.$watch('payment.useSameContact', ctrl.onUseSameContactUpdate));

        $scope.$on('$destroy', $scope.$watch('payment.paymentType', ctrl.onPaymentTypeUpdate));
        $scope.$on('$destroy', $scope.$watch('hideTicketDelivery', ctrl.onHideTicketDeliveryUpdate));

        $scope.$on('$destroy', $scope.$watch('payment.cartService.organization', ctrl.onCartOrganizationUpdate));

        $scope.$on(
          '$destroy',
          $scope.$watch(
            'payment.cartService.getMembershipItem().membershipInfo.membershipCards',
            ctrl.onCartMembershipUpdate
          )
        );

        $scope.$on('$destroy', $scope.$watch('payment.model.address', ctrl.onAddressChanged));

        ctrl.updatePaymentMethod();
      },

      isPaymentTransaction: function () {
        return ctrl.total >= 0;
      },

      getGiftCardRedemptionsTotal: function () {
        if (angular.isDefined($scope.giftCardRedemptionsTotal) && $scope.giftCardRedemptionsTotal !== null) {
          return $scope.giftCardRedemptionsTotal;
        }
        return getGiftCardRedemptionsTotal(CartService.getModel().giftCardRedemptions);
      },

      /** Amount still owed after applying gift card redemptions (never below 0). */
      getAmountDue: function () {
        return Math.max(0, ctrl.total - ctrl.getGiftCardRedemptionsTotal());
      },

      /**
       * True when applied gift cards cover the whole order — there is nothing
       * left to charge, so credit card entry/validation is skipped.
       */
      isFullyCoveredByGiftCard: function () {
        const redemptionsTotal = ctrl.getGiftCardRedemptionsTotal();
        return redemptionsTotal > 0 && ctrl.total - redemptionsTotal <= 0;
      },

      getTransactionTypeByTotal: function () {
        return ctrl.isPaymentTransaction() ? 'Payment' : 'Refund';
      },

      toggleAddNewCCPayment: function () {
        ctrl.showPayment = !ctrl.showPayment;
      },

      /**
       * You cannot add a card if is a refund, has subscription and has autorenew in the cart
       */
      canAddARNewCard: function () {
        const hasRefunds = (ctrl.vm.refund?.refundDetails?.length ?? 0) > 0;

        if (ctrl.vm.autorenewInCart.enabled && hasRefunds && ctrl.vm.hasSubscription) {
          return false;
        }

        if (hasRefunds && ctrl.vm.hasSubscription) {
          return false;
        }

        return ctrl.vm.total > 0;
      },

      setTicketDeliveryVisibility: function () {
        if ($scope.hideTicketDelivery === false || $scope.hideTicketDelivery === 'false') {
          ctrl.hideTicketDelivery = false;
        } else {
          ctrl.hideTicketDelivery = true;
        }
      },

      showAutoRenewModal: function () {
        $scope.showModal();
      },

      isPaymentPolicyType: function (type) {
        const policyType = $scope.paymentPolicy && $scope.paymentPolicy.type ? $scope.paymentPolicy.type : '';
        return policyType === type;
      },

      isPaymentType: function (type) {
        return ctrl.paymentType === type;
      },

      isPaymentMethod: function (type) {
        return ctrl.model.type === type;
      },

      isAddressRequired: function () {
        return $scope.isAddressRequired === 'true' || $scope.isAddressRequired === true;
      },

      validateAmount: function () {
        const validators = ctrl.getPaymentManualValidators();

        if (!ValidateService.validate(validators)) {
          ctrl.otherChargeAmount = 0;
          ctrl.chargeAmount = 0;
        } else {
          ctrl.otherChargeAmount = parseFloat(ctrl.otherChargeAmount as TODO);
          ctrl.chargeAmount = ctrl.otherChargeAmount;

          if (ctrl.chargeAmount > ctrl.total) {
            ctrl.chargeAmount = ctrl.total;
            ctrl.otherChargeAmount = ctrl.total;
          }
        }

        ctrl.errors = ValidateService.getErrorHash();

        const processData = ctrl.getPaymentProcessData();
        paymentService.send({ type: 'Payment::Update::ChargeAmount', params: { chargeAmount: processData.amount } });
      },

      updateContact: function (contact) {
        if (contact.email) {
          ctrl.model.contactEmail = contact.email;
        } else if (contact.contactEmail) {
          ctrl.model.contactEmail = contact.contactEmail;
        }
        if (contact.contactFirstName) {
          ctrl.model.contactFirstName = contact.contactFirstName;
        }
        if (contact.contactLastName) {
          ctrl.model.contactLastName = contact.contactLastName;
        }
        if (contact.phoneNumber) {
          ctrl.model.phoneNumber = contact.phoneNumber;
        }
      },

      updateContactAddress: function (address) {
        ctrl.model.address = address;
      },

      resetContact: function () {
        ctrl.model.contactEmail = '';
        ctrl.model.contactFirstName = '';
        ctrl.model.contactLastName = '';
        ctrl.model.phoneNumber = '';
      },

      resetContactAddress: function () {
        ctrl.model.address = {};
      },

      copySameContact: function () {
        ctrl.originalContact = angular.copy(ctrl.model);
        if (ctrl.sameContact) {
          ctrl.updateContact({
            contactFirstName: ctrl.sameContact.firstName,
            contactLastName: ctrl.sameContact.lastName,
            email: ctrl.sameContact.email,
            phoneNumber: ctrl.sameContact.phoneNumber,
          });
          ctrl.updateContactAddress(angular.extend({ id: ctrl.sameContact.addressId }, ctrl.sameContact.address));
        }
      },

      resetModel: function () {
        ctrl.model.contactFirstName = '';
        ctrl.model.contactLastName = '';
        ctrl.model.contactEmail = '';
        ctrl.model.phoneNumber = '';
        ctrl.model.address = {};
        ctrl.model.paymentVoucher = '';
        ctrl.model.paymentDaysAfter = '';
        ctrl.paymentVoucher = '';
        ctrl.paymentDaysAfter = 0;
        ctrl.model.notes = '';
        ctrl.model.items = [];

        ctrl.addOnQuantity = 0;
        ctrl.quantity = 0;
        ctrl.total = 0;
        ctrl.paymentMinimum = 0;
        ctrl.chargeAmount = 0;

        PaymentProcessorService.clear();
        paymentService.send({ type: 'Payment::Update::Reset' });
      },

      calculatePaymentTotal: function () {
        const balance = HelpersService.currencyFloatToInteger($scope.balance);
        let total = 0;
        if (balance) {
          total = HelpersService.currencyFloatToInteger($scope.total) + balance;
        } else {
          total = HelpersService.currencyFloatToInteger(angular.copy($scope.total));
        }

        ctrl.total = HelpersService.integerToCurrencyFloat(total);
        const processData = ctrl.getPaymentProcessData();
        paymentService.send({
          type: 'Payment::Update::Total',
          params: {
            total: ctrl.total,
            paymentType: processData.type,
            chargeAmount: processData.amount,
          },
        });
      },

      calculateMinimumPaymentAmount: function () {
        if ($scope.paymentPolicy && $scope.paymentPolicy.type) {
          if (!ctrl.isPaymentPolicyType('fullPayment') && !ctrl.isPaymentPolicyType('deferredPayment')) {
            //if minimum payment, calculate it
            if ($scope.isAccount && $scope.paymentPolicy.deposit) {
              if ($scope.paymentPolicy.deposit.minAmount > 0) {
                if (ctrl.total > $scope.paymentPolicy.deposit.minAmount) {
                  ctrl.paymentMinimum = $scope.paymentPolicy.deposit.minAmount;
                } else {
                  ctrl.paymentMinimum = ctrl.total;
                }
              } else if ($scope.paymentPolicy.deposit.percent > 0) {
                ctrl.paymentMinimum = ctrl.total * ($scope.paymentPolicy.deposit.percent / 100);
              }
            } else {
              // Payment Policy not set so set it to the total amount
              ctrl.paymentMinimum = ctrl.total;
            }
          } else {
            ctrl.paymentMinimum = ctrl.total;
          }
        }
      },

      migrate: function () {
        if (ctrl.model.type === 'Voucher') {
          ctrl.model.paymentVoucher = ctrl.paymentVoucher;
          if (ctrl.invoice) {
            ctrl.model.invoice = ctrl.invoice;
          } else {
            ctrl.model.invoice = null;
            delete ctrl.model.invoice;
          }
        } else {
          ctrl.model.paymentVoucher = null;
          delete ctrl.model.paymentVoucher;
        }

        if (ctrl.ticketDelivery === 'willCall' || ctrl.ticketDelivery === 'print') {
          ctrl.model.ticketDelivery = ctrl.ticketDelivery;
        }
      },

      getPaymentProcessData: function () {
        if (ctrl.paymentType === 'full') {
          ctrl.chargeAmount = ctrl.total;
        } else if (ctrl.paymentType === 'minimum') {
          ctrl.chargeAmount = ctrl.paymentMinimum;
        } else if (ctrl.paymentType === 'manual') {
          ctrl.chargeAmount = ctrl.otherChargeAmount;
        } else if (ctrl.paymentType === 'manual-zero') {
          ctrl.chargeAmount = 0;
        }

        if (ctrl.chargeAmount > ctrl.total) {
          ctrl.chargeAmount = ctrl.total;
        }

        // Gift card redemptions reduce what can be charged. When they fully
        // cover the order the chargeable amount is 0, which cascades to hiding
        // the credit card fields and completing the order without payment.
        const amountDue = Math.max(0, ctrl.total - ctrl.getGiftCardRedemptionsTotal());
        if (ctrl.chargeAmount > amountDue) {
          ctrl.chargeAmount = amountDue;
        }

        return {
          amount: ctrl.chargeAmount || 0,
          type: ctrl.paymentType,
        };
      },

      isAccountWithContact: function () {
        const isAccount = $scope.isAccount && ($scope.isAccount === true || $scope.isAccount === 'true');
        return isAccount && $scope.accountContact;
      },

      getPaymentManualValidators: function (): ACMEValidator[] {
        if (ctrl.paymentType !== 'manual') {
          return [];
        }

        return [
          {
            field: 'payment-manual',
            number: { message: 'Invalid amount', test: () => ctrl.otherChargeAmount },
          },
          {
            field: 'payment-manual',
            greaterThan: {
              message: 'Amount must be greater than 0',
              test: () => ({ actual: ctrl.otherChargeAmount, target: 0 }),
            },
          },
        ];
      },

      getPaymentManualError: function (): string | undefined {
        return ctrl.errors?.['payment-manual']?.message ?? undefined;
      },

      getAddressValidators: function (): ACMEValidator[] {
        return [
          // { field: 'payment-organization-country', len: { message: 'Invalid country', test: { value: ctrl.model.orgContactCountry } } },
          {
            field: 'payment-address-1',
            len: { message: 'Invalid address', test: { value: ctrl.model.contactAddressLine1 } },
          },
          { field: 'payment-city', len: { message: 'Invalid city', test: { value: ctrl.model.contactCity } } },
          {
            field: 'payment-zipcode',
            len: { message: 'Invalid city', test: { value: ctrl.model.contactZipcode } },
          },
        ];
      },

      getContactValidators: function (): ACMEValidator[] {
        const processData = ctrl.getPaymentProcessData();
        const validators: ACMEValidator[] = [];

        /**
         * ENG-248 Require first and last name all orders EXCEPT for organizations that have a contact and $0
         */
        const requireFirstAndLastName = !(processData.amount <= 0 && ctrl.isAccountWithContact());

        if (requireFirstAndLastName) {
          validators.push({
            field: 'payment-first-name',
            len: { message: 'Invalid name', test: { value: ctrl.model.contactFirstName } },
          });

          validators.push({
            field: 'payment-last-name',
            len: { message: 'Invalid name', test: { value: ctrl.model.contactLastName } },
          });
        }

        if (ctrl.validateEmail) {
          validators.push({
            field: 'payment-email',
            email: { message: 'Invalid email', test: () => ctrl.model.contactEmail },
          });
        } else {
          validators.push({
            field: 'payment-email',
            optionalEmail: { message: 'Invalid email', test: () => ctrl.model.contactEmail },
          });
        }

        return validators;
      },

      getVoucherValidators: function (): ACMEValidator[] {
        return [
          {
            field: 'payment-voucher',
            or: {
              message: 'Voucher already used on an order.',
              test: { values: [ctrl.invalidVoucher], expected: false },
            },
          },
          {
            field: 'payment-voucher',
            len: { message: 'Invalid voucher number', test: { value: ctrl.paymentVoucher } },
          },
        ];
      },

      getCCValidators: function (): ACMEValidator[] {
        return [
          {
            field: PaymentProcessorService.fields.number,
            len: {
              message: PaymentProcessorService.fields.errors.number,
              test: () => {
                return { value: ctrl.card.number.replace(/[\D\s]+/g, ''), minLength: 14 };
              },
            },
          },
          {
            field: PaymentProcessorService.fields.number,
            number: {
              message: PaymentProcessorService.fields.errors.number,
              test: () => {
                return ctrl.card.number.replace(/[\D\s]+/g, '');
              },
            },
          },
          {
            field: PaymentProcessorService.fields.cvc,
            len: {
              message: PaymentProcessorService.fields.errors.cvc,
              test: { value: ctrl.card.cvc, minLength: 3 },
            },
          },
          {
            field: PaymentProcessorService.fields.cvc,
            number: { message: PaymentProcessorService.fields.errors.cvc, test: ctrl.card.cvc },
          },
          {
            field: PaymentProcessorService.fields.exp_month,
            len: {
              message: PaymentProcessorService.fields.errors.exp_month,
              test: { value: ctrl.card.exp_month },
            },
          },
          {
            field: PaymentProcessorService.fields.exp_month,
            number: { message: PaymentProcessorService.fields.errors.exp_month, test: ctrl.card.exp_month },
          },
          {
            field: PaymentProcessorService.fields.exp_year,
            len: {
              message: PaymentProcessorService.fields.errors.exp_year,
              test: { value: ctrl.card.exp_year, minLength: 4 },
            },
          },
          {
            field: PaymentProcessorService.fields.exp_year,
            number: { message: PaymentProcessorService.fields.errors.exp_year, test: ctrl.card.exp_year },
          },
        ];
      },

      getCheckValidators: function (): ACMEValidator[] {
        return [
          {
            field: 'payment-check',
            len: { message: 'Invalid check number', test: { value: ctrl.checkNumber } },
          },
        ];
      },

      getValidators: function () {
        const validators: ACMEValidator[] = [...ctrl.getPaymentManualValidators()];

        if (!ctrl.isOrgCheckout() || (ctrl.isOrgCheckout() && ctrl.selectedContact?.type === 'other')) {
          validators.push(...ctrl.getContactValidators());

          if (
            ctrl.isOrgCheckout() &&
            ctrl.selectedContact?.type === 'other' &&
            ctrl.orgContactAddress?.type === 'other'
          ) {
            validators.push(...ctrl.getAddressValidators());

            if (ctrl.stateList.length) {
              // validators.push({ field: 'payment-organization-state', len: { message: 'Invalid state', test: { value: ctrl.model.orgContactState } } });
            } else {
              validators.push({
                field: 'payment-state-other',
                len: { message: 'Invalid state', test: { value: ctrl.model.contactStateOther } },
              });
            }
          }
        }

        if (ctrl.isPaymentMethod('CreditCard') && !ctrl.isEnabledCORSCheckout) {
          validators.push(...ctrl.getCCValidators());
        } else if (ctrl.isPaymentMethod('Voucher')) {
          validators.push(...ctrl.getVoucherValidators());
        } else if (ctrl.isPaymentMethod('Cash')) {
          // Default validators, do nothing
        } else if (ctrl.isPaymentMethod('Check')) {
          validators.push(...ctrl.getCheckValidators());
        }

        return validators;
      },

      complete: function () {
        const validators: ACMEValidator[] = [...ctrl.getPaymentManualValidators()];
        const addressData =
          $scope.hasMembership && ctrl.selectedContact?.type !== 'other'
            ? Object.assign({}, ctrl.model.address, { hasMembership: $scope.hasMembership })
            : null;

        if (!ctrl.isOrgCheckout() || (ctrl.isOrgCheckout() && ctrl.selectedContact?.type === 'other')) {
          validators.push(...ctrl.getContactValidators());
        }

        ctrl.isSubmitted = true;

        ctrl.errors = {};

        ctrl.contactErrors = false;

        const processData = ctrl.getPaymentProcessData();

        /**
         * Only validate address if amount is > 0
         * if we are about to change CC data for subscription
         * or theres an autorenew membership we have to validate CC
         */
        if (
          (!$scope.isCollapsed && ctrl.showPayment && processData.amount > 0) ||
          (ctrl.vm.hasSubscription && ctrl.showPayment && processData.amount <= 0) ||
          (!ctrl.vm.hasSubscription && ctrl.vm.autorenewInCart.enabled)
        ) {
          /**
           * AddressCreate::Complete event will fire the completePayment function
           * If errors occur no action will take place
           */
          if (
            (ctrl.isPaymentMethod('CreditCard') && ctrl.showPayment) ||
            (!ctrl.isPaymentMethod('CreditCard') && ctrl.showOptionalAddress)
          ) {
            $scope.$broadcast('AddressCreate::Check', addressData);
          } else {
            //No address to validate, so continue with payment. [See EMG-515]
            ctrl.invalidVoucher = false;
            ctrl.completePayment();
          }
        } else if (ValidateService.validate(validators)) {
          /**
           * Only validate contact info here then complete transaction
           */
          ctrl.completeTransaction({ isFree: true });
        } else {
          /**
           * Throw errors otherwise
           */
          ctrl.errors = ValidateService.getErrorHash();
          $scope.$emit('Payment::Error', 'Please correct the errors below');
        }
      },

      completePayment: function () {
        const processData = ctrl.getPaymentProcessData();
        const validators = ctrl.getValidators();

        // Check pricing model and total to see if values equal 0 before using cc
        if (ctrl.isPaymentMethod('CreditCard')) {
          if (
            processData.amount > 0 ||
            (ctrl.vm.hasSubscription && ctrl.showPayment && processData.amount <= 0) ||
            (!ctrl.vm.hasSubscription && !ctrl.refundData && ctrl.vm.autorenewInCart.enabled)
          ) {
            if (ValidateService.validate(validators)) {
              // Bypass stripe call
              PaymentProcessorService.process()
                .then((response) => ctrl.success.complete(response))
                .catch((response) => ctrl.error.complete(response));
            } else {
              ctrl.errors = ValidateService.getErrorHash();
              $scope.$emit('Payment::Error', 'Please correct the errors below');
              // next tick
              $timeout(() => {
                if (ctrl.checkoutModal.dismiss) {
                  ctrl.checkoutModal.dismiss();
                }
              }, 500);
            }
          } else {
            //next tick (for address to be populated) [See EMG-515]
            $timeout(() => {
              ctrl.completeTransaction({ isFree: true });
            }, 100);
          }
        } else if (ctrl.isPaymentMethod('Voucher')) {
          //next tick (for address to be populated) [See EMG-515]
          $timeout(() => {
            if (ValidateService.validate(validators)) {
              // Running without credit card validation
              if ($scope.isAccount && $scope.paymentPolicy.uniqueVoucherNumbers) {
                ApiService.orders
                  .detailByVoucher({
                    voucherNumber: ctrl.paymentVoucher,
                    organizationId: $scope.paymentPolicy.accountId,
                  })
                  .then((response) => ctrl.success.validateVoucher(response))
                  .catch(() => ctrl.error.validateVoucher());
              } else {
                ctrl.completeVoucherTransaction();
              }
            } else {
              ctrl.errors = ValidateService.getErrorHash();
              $scope.$emit('Payment::Error', 'Please correct the errors below');
              // next tick
              $timeout(() => {
                if (ctrl.checkoutModal.dismiss) {
                  ctrl.checkoutModal.dismiss();
                }
              }, 500);
            }
          }, 0);
        } else if (ctrl.isPaymentMethod('Cash')) {
          //next tick (for address to be populated) [See ENG-515]
          $timeout(() => {
            if (ValidateService.validate(validators)) {
              ctrl.completeCashTransaction();
            } else {
              ctrl.errors = ValidateService.getErrorHash();
              $scope.$emit('Payment::Error', 'Please correct the errors below');
              // next tick
              $timeout(() => {
                if (ctrl.checkoutModal.dismiss) {
                  ctrl.checkoutModal.dismiss();
                }
              }, 500);
            }
          }, 0);
        } else if (ctrl.isPaymentMethod('Check')) {
          //next tick (for address to be populated) [See ENG-515]
          $timeout(() => {
            if (ValidateService.validate(validators)) {
              // Running without credit card validation
              ctrl.completeCheckTransaction();
            } else {
              ctrl.errors = ValidateService.getErrorHash();
              $scope.$emit('Payment::Error', 'Please correct the errors below');
              // next tick
              $timeout(() => {
                if (ctrl.checkoutModal.dismiss) {
                  ctrl.checkoutModal.dismiss();
                }
              }, 500);
            }
          }, 0);
        } else if (ctrl.isPaymentMethod('Other')) {
          //next tick (for address to be populated) [See ENG-515]
          $timeout(() => {
            if (ValidateService.validate(validators)) {
              // Running without credit card validation
              ctrl.completeOtherPaymentTransaction();
            } else {
              ctrl.errors = ValidateService.getErrorHash();
              $scope.$emit('Payment::Error', 'Please correct the errors below');
              // next tick
              $timeout(() => {
                if (ctrl.checkoutModal.dismiss) {
                  ctrl.checkoutModal.dismiss();
                }
              }, 500);
            }
          }, 0);
        } else {
          // next tick
          $timeout(() => {
            if (ctrl.checkoutModal.dismiss) {
              ctrl.checkoutModal.dismiss();
            }
          }, 500);
        }
      },

      completeVoucherTransaction: function () {
        const payment: Partial<Payment> = {
          type: ctrl.model.type,
          paymentId: ctrl.paymentVoucher,
          chargeAmount: ctrl.total.toString(),
        };

        ctrl.migrate();

        if (ctrl.isOrgCheckout()) {
          Object.assign(payment, ctrl.getOrgBillingInfo());
        } else {
          Object.assign(payment, ctrl.getBillingInfo());
        }

        if (ctrl.model.ticketDelivery) {
          payment.ticketDelivery = ctrl.model.ticketDelivery;
        }

        if (ctrl.model.invoice) {
          payment.invoice = ctrl.model.invoice;
        }

        if (ctrl.isPaymentPolicyType('deferredPayment')) {
          payment.chargeAmount = ctrl.chargeAmount.toString();
        }

        // Send message payment up $scope chain that has been processed and complete
        $scope.$emit('Payment::Complete', payment);
      },

      completeCashTransaction: function () {
        const payment: Partial<Payment> = {
          type: ctrl.model.type,
          chargeAmount: ctrl.total.toString(),
        };

        ctrl.migrate();

        if (ctrl.isOrgCheckout()) {
          Object.assign(payment, ctrl.getOrgBillingInfo());
        } else {
          Object.assign(payment, ctrl.getBillingInfo());
        }

        if (ctrl.model.ticketDelivery) {
          payment.ticketDelivery = ctrl.model.ticketDelivery;
        }

        if (ctrl.isPaymentPolicyType('deferredPayment')) {
          payment.chargeAmount = ctrl.chargeAmount.toString();
        }

        // Send message payment up $scope chain that has been processed and complete
        $scope.$emit('Payment::Complete', payment);
      },

      completeCheckTransaction: function () {
        const payment: Partial<Payment> = {
          type: ctrl.model.type,
          paymentId: ctrl.checkNumber,
          chargeAmount: ctrl.total.toString(),
        };

        ctrl.migrate();

        if (ctrl.isOrgCheckout()) {
          Object.assign(payment, ctrl.getOrgBillingInfo());
        } else {
          Object.assign(payment, ctrl.getBillingInfo());
        }

        if (ctrl.model.ticketDelivery) {
          payment.ticketDelivery = ctrl.model.ticketDelivery;
        }

        if (ctrl.isPaymentPolicyType('deferredPayment')) {
          payment.chargeAmount = ctrl.chargeAmount.toString();
        }

        // Send message payment up $scope chain that has been processed and complete
        $scope.$emit('Payment::Complete', payment);
      },

      completeOtherPaymentTransaction: function () {
        const payment: Partial<Payment> = {
          type: ctrl.model.type,
          paymentId: ctrl.otherPaymentId,
          chargeAmount: ctrl.total.toString(),
        };

        ctrl.migrate();

        if (ctrl.isOrgCheckout()) {
          Object.assign(payment, ctrl.getOrgBillingInfo());
        } else {
          Object.assign(payment, ctrl.getBillingInfo());
        }

        if (ctrl.model.ticketDelivery) {
          payment.ticketDelivery = ctrl.model.ticketDelivery;
        }

        if (ctrl.isPaymentPolicyType('deferredPayment')) {
          payment.chargeAmount = ctrl.chargeAmount.toString();
        }

        // Send message payment up $scope chain that has been processed and complete
        $scope.$emit('Payment::Complete', payment);
      },

      completeTransaction: function ({ isFree }: { isFree: boolean }) {
        let expMonth;
        const card = angular.copy(PaymentProcessorService.model);
        const payment: Partial<Payment> = {
          type: ctrl.model.type,
          acmeToken: null,
          manualEntryCardNumber: null,
          expDate: null,
          creditCardBrand: null,
          ccLastFourDigits: null,
          cvc: null,
        };

        ctrl.migrate();

        if (ctrl.isOrgCheckout()) {
          Object.assign(payment, ctrl.getOrgBillingInfo());
        } else {
          Object.assign(payment, ctrl.getBillingInfo());
        }

        if (ctrl.model.ticketDelivery) {
          payment.ticketDelivery = ctrl.model.ticketDelivery;
        }

        // TODO: distinguish between deferred/partial payment with 0 amount and full payment policy (where chargeAmount is not specified)
        const processData = ctrl.getPaymentProcessData();
        if (processData.type === 'minimum' || processData.type === 'manual-zero' || processData.type === 'manual') {
          payment.chargeAmount = processData.amount.toString();
        }

        if (!isFree) {
          payment.acmeToken = card.acmeToken;
          payment.creditCardBrand = card.creditCardBrand;
          payment.ccLastFourDigits = card.ccLastFourDigits;
          payment.manualEntryCardNumber = card.number;
          payment.cvc = card.cvc;
          expMonth = parseInt(card.exp_month, 10);
          if (!isNaN(expMonth)) {
            if (expMonth > 0 && expMonth < 10) {
              payment.expDate = '0' + expMonth + card.exp_year.substr(2, 2);
            } else {
              payment.expDate = card.exp_month + card.exp_year.substr(2, 2);
            }
          }
        } else {
          payment.chargeAmount = '0';
        }

        if (
          !ctrl.isEnabledCORSCheckout &&
          ((ctrl.vm.hasSubscription && !ctrl.showPayment) || processData.type === 'manual-zero')
        ) {
          payment.type = 'Cash';
        }

        payment.hasSubscription = !!(ctrl.vm.hasSubscription && ctrl.showPayment);

        // Send message payment up $scope chain that has been processed and complete
        $scope.$emit('Payment::Complete', payment);
      },

      getSecureCheckoutData: function () {
        const card = angular.copy(PaymentProcessorService.card);
        const processData = ctrl.getPaymentProcessData();
        const amount = processData.amount.toString();
        const contact = ctrl.model;
        const address = ctrl.model.address as Address;

        const props = {
          pan: card.number ?? undefined,
          phone: contact.phoneNumber ?? undefined,
          amount: amount,
          email: contact.contactEmail ?? undefined,
          firstName: contact.contactFirstName ?? undefined,
          lastName: contact.contactLastName ?? undefined,
          streetAddress: address.streetAddress1 ?? undefined,
          zipCode: address.zipCode ?? undefined,
          city: address.city ?? undefined,
        } as SecureCheckoutProps;

        paymentService.setSecureCheckoutProps(props);

        $scope.$broadcast('Payment::SetSecureCheckoutData');
      },

      getBillingInfo: function () {
        const payment: Partial<Payment> = {};

        const ccValidationSettings = ThemesHelperService.getCCValidationSettings();
        let display: 'address' | 'zipcode' = 'address';

        if (ccValidationSettings.hasOwnProperty('b2bDisplay')) {
          display = ccValidationSettings.b2bDisplay.toLowerCase();
        }

        if (ctrl.model.contactEmail) {
          payment.contactEmail = ctrl.model.contactEmail;
        }

        if (ctrl.model.contactFirstName) {
          payment.contactFirstName = ctrl.model.contactFirstName;
        }

        if (ctrl.model.contactLastName) {
          payment.contactLastName = ctrl.model.contactLastName;
        }

        if (ctrl.model.phoneNumber) {
          payment.phoneNumber = ctrl.model.phoneNumber;
        }

        if (ctrl.model.address) {
          if (display === 'zipcode') {
            const { zipCode, country, otherCountry, type, isPrimary } = ctrl.model.address;
            payment.address = { zipCode, country, otherCountry, type, isPrimary };
          } else {
            payment.address = ctrl.model.address;
          }
        }

        return payment;
      },

      getOrgBillingInfo: function () {
        const payment: Partial<Payment> = {};

        if (ctrl.organization?.paymentSectionCollapsed) {
          payment.contactFirstName = '';
          payment.contactLastName = '';
          payment.phoneNumber = '';
          payment.address = '';
        } else if (ctrl.selectedContact && ctrl.selectedContact.type !== 'other') {
          payment.contactEmail = ctrl.selectedContact.email;
          payment.contactFirstName = ctrl.selectedContact.firstName;
          payment.contactLastName = ctrl.selectedContact.lastName;
          payment.phoneNumber = ctrl.selectedContact.phoneNumber;
          payment.address = ctrl.selectedContact;
        } else {
          ctrl.getBillingInfo();
          if (ctrl.orgContactAddress.type !== 'other') {
            payment.address = ctrl.orgContactAddress;
          } else {
            payment.address = {};

            if (this.payment.model.contactAddressLine1) {
              payment.address.streetAddress1 = this.payment.model.contactAddressLine1;
            }

            if (this.payment.model.contactAddressLine2) {
              payment.address.streetAddress2 = this.payment.model.contactAddressLine2;
            }

            if (this.payment.model.contactCity) {
              payment.address.city = this.payment.model.contactCity;
            }

            if (ctrl.stateList.length) {
              payment.address.state = this.payment.model.orgContactState;
            } else {
              payment.address.state = this.payment.model.contactStateOther;
            }

            if (this.payment.model.contactZipcode) {
              payment.address.zipCode = this.payment.model.contactZipcode;
            }

            if (this.payment.model.orgContactCountry) {
              payment.address.country = this.payment.model.orgContactCountry;
            }
          }
        }
        return payment;
      },

      isOrgCheckout: function () {
        return !!$scope.showOrgBilling && !!ctrl.organization;
      },

      searchOrganizationContacts: function () {
        const props = HelpersService.getPaginator();

        props.sortField = 'firstName';

        if (ctrl.organization?.id) {
          ApiService.organizations.contacts
            .list(Object.assign(props, { organizationId: ctrl.organization.id }))
            .then((response) => ctrl.success.searchOrganizationContacts(response))
            .catch((response) => ctrl.error.searchOrganizationContacts(response));
        }
      },

      processContacts: function (list) {
        const options = [
          {
            name: 'Other',
            type: 'other',
          },
        ];

        list = list.concat(options);

        return list.map((item) => {
          item.name = ctrl.generateFullName(item);

          if (!item.address) {
            item.address = ctrl.getContactAddress(item);
          }

          if (!item.type) {
            item.type = 'contact';
          }

          return item;
        });
      },

      generateFullName: function (contact) {
        const name: string[] = [];

        if (contact.salutation) {
          name.push(contact.salutation);
        }

        if (contact.firstName) {
          name.push(contact.firstName);
        }

        if (contact.middleName) {
          name.push(contact.middleName);
        }

        if (contact.lastName) {
          name.push(contact.lastName);
        }

        if (!contact.firstName && !contact.lastName && contact.name) {
          name.push(contact.name);
        }

        if (contact.postfix) {
          name.push(contact.postfix);
        }

        return name.join(' ');
      },

      getContactAddress: function (contact) {
        const address: string[] = [];
        const location: string[] = [];

        if (contact.streetAddress1) {
          address.push(contact.streetAddress1);
        }

        if (contact.streetAddress2) {
          address.push(contact.streetAddress2);
        }

        if (contact.city) {
          location.push(contact.city);
        }

        if (contact.state) {
          location.push(contact.state);
        }

        if (contact.zipCode) {
          location.push(contact.zipCode);
        }

        if (contact.country) {
          location.push(contact.country);
        }

        const result: { address?: string; location?: string } = {};

        if (address.length) {
          result.address = address.join(' ');
        }

        if (location.length) {
          result.location = location.join(' ');
        }

        return result;
      },

      setSelectedMembershipContact: function () {
        if (ctrl.selectedContact && ctrl.selectedContact.type !== 'other') {
          ctrl.model.contactFirstName = ctrl.selectedContact.firstName;
          ctrl.model.contactLastName = ctrl.selectedContact.lastName;
          ctrl.model.contactEmail = ctrl.selectedContact.email || '';
          ctrl.model.phoneNumber = ctrl.selectedContact.phoneNumber || '';
        } else {
          ctrl.model.contactFirstName = '';
          ctrl.model.contactLastName = '';
          ctrl.model.contactEmail = '';
          ctrl.model.phoneNumber = '';
        }

        if (ctrl.selectedContact && ctrl.selectedContact.address) {
          ctrl.model.address = ctrl.selectedContact.address;
        } else {
          ctrl.model.address = {
            country: ThemesHelperService.getCompany('country') || 'United States',
          };
        }
      },

      attemptToGetPrimaryContact: function () {
        if (!ctrl.organization) {
          return;
        }

        if (ctrl.organization.primaryContact) {
          return ctrl.organization.primaryContact;
        }

        return ctrl.contactList.find((contact) => {
          return contact.primary;
        });
      },

      setSelectedContact: function () {
        if ($scope.hasMembership) {
          ctrl.selectedContact = ctrl.contactList[0];
          ctrl.setSelectedMembershipContact();
        } else if (ctrl.organization) {
          const primaryContact = ctrl.attemptToGetPrimaryContact();

          if (primaryContact) {
            ctrl.selectedContact = primaryContact;
          }
        }
      },

      updateOrgContact: function () {
        if (ctrl.selectedContact) {
          switch (ctrl.selectedContact.type) {
            case 'new':
              ctrl.addOrganizationContact();
              break;
            default:
              // ctrl.selectedContact.address = ctrl.getContactAddress(ctrl.selectedContact);
              break;
          }
        }
      },

      editOrganizationContact: function () {
        ctrl.addOrganizationContact(true);
      },

      addOrganizationContact: function (edit = false) {
        const contact = edit ? ctrl.selectedContact : null;
        $uibModal
          .open<TODO>({
            templateUrl: 'views/application/views/partners/create/modals/ManageSecondaryContactModal.tpl.html',
            size: 'lg',
            controller: 'ManageSecondaryContactModalController',
            resolve: {
              ValidateService: () => ValidateService,
              alertMessage: () => null,
              organizationId: () => ctrl.organization?.id,
              organizationName: () => ctrl.organization?.name,
              contact: () => contact,
              address: () => null,
            },
          })
          .result.then((contact) => {
            contact.organizationId = ctrl.organization?.id;
            if (edit) {
              return ApiService.organizations.contacts
                .update(contact)
                .then((response) => ctrl.success.addOrganizationContact(response))
                .catch((response) => ctrl.error.addOrganizationContact(response));
            } else {
              return ApiService.organizations.contacts
                .create(contact)
                .then((response) => ctrl.success.addOrganizationContact(response))
                .catch((response) => ctrl.error.addOrganizationContact(response));
            }
          })
          .catch(() => {
            ctrl.selectedContact = contact;
          });
      },

      getOrgAddresses: function () {
        ApiService.organizations.addresses
          .list({ organizationId: this.organization.id })
          .then((response) => ctrl.success.getOrgAddresses(response))
          .catch(() => {
            // noop
          });
      },

      proccessOrgAddress: function (list) {
        list.push({
          name: '+ other',
          type: 'other',
        });
        return list.map((item) => {
          const fullAddress = ctrl.getContactAddress(item);
          if (item.type !== 'other') {
            item.name = fullAddress.address + ' ' + fullAddress.location;
          }
          return item;
        });
      },

      getCountries: function () {
        ApiService.form.avs
          .countries()
          .then((response) => ctrl.success.getCountries(response))
          .catch((response) => ctrl.error.getCountries(response));
      },

      getStates: function () {
        ApiService.form.states
          .list({ country: ctrl.model.orgContactCountry.alpha2Code.toLowerCase() })
          .then((response) => ctrl.success.getStates(response))
          .catch((response) => ctrl.error.getStates(response));
      },

      getRefundMethods: function () {
        const membership = CartService.getMembershipItem();
        const props: OrdersCheckoutChargesInput = {
          memberships: [
            {
              itemType: membership.itemType,
              membershipInfo: {
                membershipId: membership.membershipInfo.membershipId,
                membershipOfferingId: membership.membershipInfo.membershipOfferingId,
                waiveBenefits: false,
                pricePointId: membership.membershipInfo.pricePointId,
                notifyGiftRecipient: false,
                isGift: membership.membershipInfo.isGift,
                membershipCategoryId: membership.membershipInfo.membershipCategoryId,
                membershipCards: membership.membershipInfo.membershipCards,
              },
            },
          ],
        };

        return paymentService
          .getRefundData(props)
          .then((payload) => {
            const refundDetails: RefundDetailsVM[] =
              payload.refundDetails
                ?.filter((detail) => Number(detail.refundAmount))
                .map((detail) => {
                  let paymentMethodDescription = '';

                  switch (detail.paymentMethod) {
                    case 'CreditCard':
                      paymentMethodDescription = 'Credit Card x' + detail.ccLastFourDigits;
                      break;

                    case 'Voucher':
                    case 'Check':
                      paymentMethodDescription = detail.paymentMethod + ' #' + detail.paymentId;
                      break;

                    default:
                      paymentMethodDescription = detail.paymentMethod;
                      break;
                  }

                  return { ...detail, paymentMethodDescription };
                }) ?? [];

            return { ...payload, refundDetails };
          })
          .catch((error) => {
            return null;
          });
      },

      setShowPayment: function () {
        const hasSubscription = ctrl.vm.hasSubscription;
        const hasMembershipsInCart = ctrl.vm.hasMembershipsInCart;
        const isMembershipRenewal = !ctrl.vm.hasNewMembership;
        const hasAutorenewOptedinInCart = ctrl.vm.autorenewInCart.isAutorenew && ctrl.vm.autorenewInCart.enabled;

        const autorenewToAutorenew = hasSubscription && hasAutorenewOptedinInCart;
        const autorenewToNonAutorenew = hasSubscription && !hasAutorenewOptedinInCart;
        const nonAutorenewToNonAutorenew = !hasSubscription && !hasAutorenewOptedinInCart;
        const nonAutorenewToAutorenew = !hasSubscription && hasAutorenewOptedinInCart;

        /**
         * all specific cases when is shown or not payment fields
         *  payment is always required if total > 0
         *  payment is always required if total = 0, unless:
         *    - we have a membership renewal and its AR to non AR
         *    - we have a membership renenwal and its non AR to non AR
         *  payment is never required if total < 0, unless:
         *    - we have a renewal and its non AR to AR
         */
        switch (ctrl.vm.paymentType) {
          case 'PAYMENT_OWED':
            ctrl.showPayment = true;
            break;
          case 'NO_PAYMENT_OWED':
            ctrl.showPayment = true;

            if (hasMembershipsInCart) {
              if (isMembershipRenewal) {
                if (autorenewToAutorenew) {
                  ctrl.showPayment = true;
                }

                if (autorenewToNonAutorenew) {
                  ctrl.showPayment = false;
                }

                if (nonAutorenewToNonAutorenew) {
                  ctrl.showPayment = false;
                }

                if (nonAutorenewToAutorenew) {
                  ctrl.showPayment = true;
                }
              }
            }

            break;
          case 'REFUND_OWED':
            ctrl.showPayment = false;

            if (hasMembershipsInCart) {
              if (isMembershipRenewal) {
                if (autorenewToAutorenew) {
                  ctrl.showPayment = false;
                  break;
                }

                if (autorenewToNonAutorenew) {
                  ctrl.showPayment = false;
                  break;
                }

                if (nonAutorenewToNonAutorenew) {
                  ctrl.showPayment = false;
                  break;
                }

                if (nonAutorenewToAutorenew) {
                  ctrl.showPayment = false;
                  break;
                }
              }
            }

            break;
          default:
            ctrl.showPayment = true;
            break;
        }
      },

      success: {
        complete: function (response) {
          // If successfully processed credit card via complete complete the transaction
          ctrl.completeTransaction({ isFree: false });
        },
        validateVoucher: function (data) {
          ctrl.invalidVoucher = true;
          ValidateService.validate(ctrl.getValidators());
          ctrl.errors = ValidateService.getErrorHash();
          $scope.$emit('Payment::Error', 'Please correct the errors below');
          // next tick
          $timeout(() => {
            if (ctrl.checkoutModal.dismiss) {
              ctrl.checkoutModal.dismiss();
            }
          }, 500);
        },

        searchOrganizationContacts: function (response) {
          ctrl.contactList = ctrl.processContacts(response.data.payload.list);
          ctrl.setSelectedContact();
        },

        addOrganizationContact: function (response) {
          const contact = response.data.payload;
          contact.name = ctrl.generateFullName(contact);
          contact.address = ctrl.getContactAddress(contact);

          ctrl.selectedContact = contact;
        },

        getOrgAddresses: function (response) {
          ctrl.addressList = ctrl.proccessOrgAddress(response.data.payload.list);
          if (ctrl.addressList.length) {
            ctrl.orgContactAddress = ctrl.addressList[0];
          }
        },

        getCountries: function (response) {
          ctrl.countryList = response.data.payload;
          ctrl.model.orgContactCountry = ctrl.countryList[0];
          ctrl.getStates();
        },

        getStates: function (response) {
          ctrl.stateList = response.data.payload;
          ctrl.model.orgContactState = ctrl.stateList[0];
        },
      },

      error: {
        complete: function (response: { data: PaymentProcessError }) {
          if (ctrl.checkoutModal.dismiss) {
            ctrl.checkoutModal.dismiss();
          }

          ValidateService.validate(PaymentProcessorService.mapError(response.data.code));
          ctrl.errors = ValidateService.getErrorHash();
          $scope.$emit('Payment::Error', response.data.error);

          console.log('Payment::error::paymentProcessor', ctrl.errors);
        },
        validateVoucher: function () {
          ctrl.completeVoucherTransaction();
        },

        searchOrganizationContacts: function (response) {},
        addOrganizationContact: function (response) {},
        getCountries: function (response) {},
        getStates: function (response) {},
      },

      onPaymentProcessError: function (e, data) {
        ctrl.error.complete(data.response);
      },

      onPaymentProcess: function (e, data) {
        if (data && data.hasOwnProperty('validateEmail')) {
          ctrl.validateEmail = data.validateEmail;
        }
        ctrl.complete();
      },

      onPaymentReset: function (e, data) {
        ctrl.resetModel();
      },

      onExternalErrorsUpdate: function (newValue, oldValue) {
        if (Array.isArray(newValue) && newValue.length > 0) {
          ctrl.notice.showErrorMessages(newValue);
        } else {
          ctrl.notice.hideErrorMessages();
        }
      },

      onPaymentPolicyUpdate: function (n, o) {
        if ($scope.isAccount) {
          if (n && n.ticketDelivery) {
            ctrl.ticketDelivery = n.ticketDelivery;
          } else {
            ctrl.ticketDelivery = 'willCall';
          }
        } else {
          ctrl.ticketDelivery = 'print';
        }
      },

      onPaymentMethodUpdateLegacy: function () {
        const paymentMethod = ctrl.paymentMethods.find((item) => item.type === ctrl.model.type);

        if (paymentMethod && paymentMethod !== ctrl.paymentMethod) {
          ctrl.paymentMethod = paymentMethod;
        }

        ctrl.updatePaymentMethod();
      },

      updatePaymentMethod: function () {
        if (ctrl.paymentMethod && ctrl.paymentMethod.type) {
          ctrl.model.type = ctrl.paymentMethod.type;
          $scope.$emit('Payment::Update::PaymentMethod', { paymentMethod: ctrl.model.type });
          paymentService.send({ type: 'Payment::Update::PaymentMethod', params: { paymentMethod: ctrl.model.type } });
        }
      },

      onPaymentMethodUpdate: function (e, data) {
        ctrl.updatePaymentMethod();
      },

      onPaymentTypeUpdate: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          const paymentType = newValue;
          const processData = ctrl.getPaymentProcessData();

          $scope.$emit('Payment::Update::PaymentType', { paymentType });
          paymentService.send({
            type: 'Payment::Update::PaymentType',
            params: { paymentType, chargeAmount: processData.amount },
          });
        }
      },

      onTotalUpdate: function (n, o) {
        ctrl.calculatePaymentTotal();
        ctrl.calculateMinimumPaymentAmount();

        if (CartService.getMembershipItem() && $scope.total < 0) {
          ctrl.getRefundMethods().then((refundData) => {
            ctrl.refundData = refundData;
          });
        }
      },

      /**
       * Recompute chargeAmount when applied gift card redemptions change, for
       * hosts (org order checkout/payment) that supply `giftCardRedemptionsTotal`
       * directly instead of going through CartService. Without this, applying a
       * gift card never re-runs calculatePaymentTotal(), so paymentService's
       * chargeAmount/requiresCardData stay stale at their pre-redemption values.
       */
      onGiftCardRedemptionsTotalUpdate: function () {
        ctrl.calculatePaymentTotal();
      },

      onContactUpdate: function (n, o) {
        if (n !== o) {
          ctrl.updateContact(n);
        }
      },

      onUseSameContactUpdate: function (n, o) {
        if (n !== o) {
          ctrl.useSameContact = n;
          if (n) {
            ctrl.copySameContact();
          } else {
            ctrl.resetContact();
            ctrl.resetContactAddress();
          }
        }
      },

      onSameContactUpdate: function (n, o) {
        if (n !== o) {
          ctrl.sameContact = $scope.sameContact;
          if (ctrl.useSameContact) {
            ctrl.copySameContact();
          }
        }
      },

      onAddressCreateComplete: function (e, data) {
        ctrl.invalidVoucher = false;
        ctrl.completePayment();
        console.log(data);
      },

      onAddressCreateCheckSuccess: function (e, data) {
        $scope.$broadcast('AddressCreate::Process');

        if (!CheckoutProcessService.isEnabledCORSCheckout()) {
          /**
           * Only open processing modal after downstream
           * address module has returned successfully
           */
          ctrl.checkoutModal = $uibModal.open({
            templateUrl: 'common/views/modals/checkout/checkout.tpl.html',
            size: 'lg',
            controller: 'ModalsCheckoutController',
            backdrop: 'static',
          });
        }

        console.log(data);
      },

      onAddressCreateCheckError: function (e, data) {
        $scope.$emit('Payment::Error', 'Please correct errors below');
        ValidateService.validate(ctrl.getValidators());
        ctrl.errors = Object.assign({}, ValidateService.getErrorHash(), data.errors);

        if ($scope.hasMembership && data.errors) {
          ctrl.contactErrors = data.errors;
        }
      },

      onAddressCreateError: function (e, data) {
        $scope.$emit('Payment::Error', 'Please correct errors below');
        ValidateService.validate(ctrl.getValidators());
        ctrl.errors = ValidateService.getErrorHash();
      },

      onHideTicketDeliveryUpdate: function (n, o) {
        if (n !== o) {
          ctrl.setTicketDeliveryVisibility();
        }
      },

      onDestroy: function (e, data) {
        ctrl.resetModel();
      },

      isAriaInvalid: function (name) {
        return ctrl.errors[name] && ctrl.errors[name].message;
      },

      getPrimaryCardholder: function (contacts) {
        return coerceArray(contacts)
          .map((contact, index) => ({ ...contact, index }))
          .find((contact) => contact.cardType === 'primary');
      },

      showCardModal: function () {
        $scope.$emit('Payment::showCardModal', {
          index: ctrl.selectedContact?.index,
        });
      },

      onCartOrganizationUpdate: function (n, o) {
        if (n && n.id) {
          ctrl.organization = ctrl.cartService.getOrganization();
          ctrl.searchOrganizationContacts();
          ctrl.getOrgAddresses();
          ctrl.getCountries();
        }
      },

      onCartMembershipUpdate: function () {
        const membershipItem = ctrl.cartService.getMembershipItem();
        const contacts = HelpersService.path(membershipItem, ['membershipInfo', 'membershipCards'], [])
          .map(ctrl.getPrimaryCardholder)
          .filter(Boolean);

        ctrl.contactList = ctrl.processContacts(contacts); //once we start accepting more than the primary cardholder, we will remove the [0]
        ctrl.setSelectedContact();
      },

      onOrganizationContactChange: function (e, data) {
        ctrl.updateOrgContact();
      },

      onOrgCountryUpdate: function (e, data) {
        ctrl.getStates();
      },

      onSelectedContactUpdate: function () {
        ctrl.setSelectedMembershipContact();
      },

      onAddressChanged: function (newValue: PaymentAddress, oldValue: PaymentAddress) {
        $scope.addressChanged({ $event: newValue });
      },
    };

    $scope.payment = ctrl;
    $scope.$ctrl = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/payment/payment.tpl.html',
    scope: {
      allowInvoice: '@',
      hideOnManualZero: '@',
      hidePaymentMethods: '@',
      hideTicketDelivery: '@',
      total: '=',
      balance: '=',
      contact: '=',
      isMember: '=',
      isAccount: '=',
      accountContact: '@',
      paymentPolicy: '=',
      isAddressRequired: '=',
      sameContact: '=?',
      useSameContact: '=?',
      sameContactTypeLabel: '@',
      layout: '@',
      focusPaymentField: '@',
      showOrgBilling: '=',
      organizationId: '=',
      isCollapsed: '=',
      hasMembership: '=',
      hasCardholders: '=',
      externalErrors: '<',
      corsCheckoutCreditCardMessage: '<',
      giftCardRedemptionsTotal: '<?',
      giftCardAmountDue: '<?',
      reservationId: '<?',
      orderId: '<?',
      initialGiftCardRedemptions: '<?',
      onGiftCardRedemptionsChange: '&?',
      showModal: '&',
      addressChanged: '&',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: PaymentController,
  };
}

export const PaymentDirectiveModule = angular
  .module('acme.common.directive.payment', [
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.paymentProcessor',
    'acme.common.service.validate',
    'acme.common.service.helpers',
    CartServiceModule,
    PaymentServiceModule,
    'acme.common.service.themesHelper',
    'acme.common.factory.notice',
    GiftCardRedemptionComponentModule,
    'acme.common.directive.numeric',
    'acme.common.directive.combobox',
    'acme.common.directive.paymentContactInfo',
    NoticesComponentModule,
    'acme.view.application.modals.checkout.controllers',
    ManageSecondaryContactModalModule,
    CartSecureCheckoutComponentModule,
    CheckoutProcessServiceModule,
    MaskDirectiveModule,
  ])
  .directive('payment', PaymentDirective).name;
